module.exports = {"subnavLinks":[{"label":"Resumo","link":"/minha-veloe/:id/resumo","id":"mnuSummary"},{"label":"Lançamentos","link":"/minha-veloe/:id/lancamentos","id":"mnuNews"},{"label":"Repasses","link":"/minha-veloe/:id/repasses","id":"mnuPass"}]}


//////////////////
// WEBPACK FOOTER
// ./src/app/templates/ec/TemplateECDashboard/data.json
// module id = 2227
// module chunks = 0